export const socials = {
	instagram: 'https://www.instagram.com/kjmc.network/',
	telegram: 'https://t.me/KemoNews_bot',
	facebook: 'https://www.facebook.com/kemokiev',
	youtube: 'https://www.youtube.com/@KEMOnetwork',
	email: 'officekemo@gmail.com'
}
